import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import BgIcon from 'components/atoms/icons/condition-filter-bg.svg?react';
import classNames from 'classnames';
import common from 'constants/common';
import InformationTooltip from 'components/atoms/information-tooltip';
import { ModuleType } from 'infrastructure/enums';

import s from './styles.module.scss';

import type {
  ICcmOnboardingStatusResponse,
  IRpmOnboardingStatusResponse,
} from 'infrastructure/interfaces';
import type { FC } from 'react';

const ccmLoadingStatuses: ICcmOnboardingStatusResponse['statuses'] = {
  'CCM Calling Queue': 0,
  'CCM Patient Refused': 0,
  'CCM Onboarding': 0,
  'CCM Onboarding Unsuccessful': 0,
  'CCM Referral Received': 0,
  'CCM Referral On-Hold': 0,
  'CCM Referral Withdrawn': 0,
  'CCM Patient No Contact': 0,
  'Total CCM Patients': 0,
  Active: 0,
};

const rpmLoadingStatuses: IRpmOnboardingStatusResponse['statuses'] = {
  patient_referral: 0,
  referral_on_hold: 0,
  referral_withdrawn: 0,
  calling_queue: 0,
  patient_no_contact: 0,
  refused: 0,
  insurance_refused: 0,
  onboarding: 0,
  onboarding_unsuccessful: 0,
  total: 0,
  active: 0,
};

const loadingStatuses: Record<ModuleType, Partial<StatusBlocks>> = {
  [ModuleType.CCM]: ccmLoadingStatuses,
  [ModuleType.RPM]: rpmLoadingStatuses,
  [ModuleType.RPMCCM]: {},
  [ModuleType.ADMIN]: {},
};

type StatusBlocks =
  | ICcmOnboardingStatusResponse['statuses']
  | IRpmOnboardingStatusResponse['statuses'];

interface StatusCountProps {
  statuses?: StatusBlocks;
  loading: boolean;
  module: ModuleType;
}

const OnboardingStatusCount: FC<StatusCountProps> = ({
  statuses,
  loading,
  module,
}) => {
  let titles: Record<
    string,
    { label: string; color: string; description: string }
  > = {};
  if (module === ModuleType.CCM) {
    titles = common.ccmStatusNames;
  } else {
    titles = common.statusNames;
  }

  return (
    <BaseSpinWrapper spinning={loading}>
      <div className={s.wrapper}>
        {Object.entries(statuses ?? loadingStatuses[module]).map(
          ([key, value]) => {
            type TKey = keyof typeof titles;
            const { label, color, description } = titles[key as TKey];

            if (module === ModuleType.RPM && key === 'total') {
              return null;
            }

            return (
              <div
                className={classNames(s.item, { [s.active]: false })}
                key={label ?? ''}
              >
                <p className={s.title}>{label}</p>
                <p className={s.count}>{value}</p>
                <BgIcon className={s.bg} color={color} />
                {description && (
                  <div className={s['info-content-wrapper']}>
                    <InformationTooltip content={description} trigger="hover" />
                  </div>
                )}
              </div>
            );
          },
        )}
      </div>
    </BaseSpinWrapper>
  );
};
export default OnboardingStatusCount;
